import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
export function AdvisoryFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: 'I have a bookkeeper; why do I need a Fractional CFO?',
    answer: 'Your bookkeeper records history; I help you write the future. I translate your data into a strategic roadmap for growth and profitability—identifying where cash is trapped, which customers are truly profitable, and what investments will generate the highest returns.'
  }, {
    question: 'We aren\'t looking to sell for years. Is "Exit Readiness" relevant?',
    answer: 'Yes. A "buyer-ready" business is simply a well-run business. Operating with that mindset today makes your company more profitable and less stressful to manage right now. Clean financials, documented processes, and clear KPIs benefit you whether you sell in 2 years or 20.'
  }, {
    question: 'How do we get started?',
    answer: "We start with a 20-minute diagnostic call to identify your biggest financial bottleneck. I'll provide one actionable insight you can use immediately—no strings attached. From there, we can discuss whether a deeper engagement makes sense."
  }, {
    question: 'What size businesses do you typically work with?',
    answer: "I work primarily with SMBs and non-profits in the $1M–$50M revenue range. These are businesses that have outgrown basic bookkeeping but aren't ready for a full-time CFO. If you're not sure whether you're a fit, the diagnostic call will help us both figure that out."
  }, {
    question: 'How is this different from hiring a consulting firm?',
    answer: "I'm not here to produce a 100-page report that sits on a shelf. I embed into your operations, build the systems myself, and ensure they actually get implemented. Think of it as having a senior finance executive on your team—without the $300K+ salary."
  }];
  return <section className="w-full py-24 sm:py-32 px-6 sm:px-8 bg-white" data-id="element-36">
      <div className="max-w-3xl mx-auto" data-id="element-37">
        <div className="text-center mb-14" data-id="element-38">
          <p className="text-gold-500 text-sm font-semibold tracking-[0.2em] uppercase mb-4" data-id="element-39">
            FAQ
          </p>
          <h2 className="text-3xl sm:text-4xl font-serif text-navy-900" data-id="element-40">
            Common Questions
          </h2>
        </div>

        <div className="space-y-3" data-id="element-41">
          {faqs.map((faq, index) => <div key={index} className={`rounded-lg border transition-all duration-300 ${openIndex === index ? 'border-gold-500/30 bg-slate-50' : 'border-slate-200 hover:border-slate-300'}`} data-id="element-42">
              <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-43">
                <span className="font-semibold text-[15px] text-navy-900 pr-6" data-id="element-44">
                  {faq.question}
                </span>
                <span className={`flex-shrink-0 transition-colors ${openIndex === index ? 'text-gold-500' : 'text-slate-400'}`} data-id="element-45">
                  {openIndex === index ? <Minus size={18} data-id="element-46" /> : <Plus size={18} data-id="element-47" />}
                </span>
              </button>

              <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-60' : 'max-h-0'}`} data-id="element-48">
                <p className="px-6 pb-6 text-slate-600 text-[15px] leading-relaxed" data-id="element-49">
                  {faq.answer}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}